/**
 * In-App Notification Types
 */

export enum NotificationCategory {
  EXPENSE = 'EXPENSE',
  NOMINATION = 'NOMINATION',
  PERFORMANCE = 'PERFORMANCE',
  TIMESHEET = 'TIMESHEET',
  // Stored as a plain String in AppSync, so adding a category needs no schema change.
  LEAVE = 'LEAVE',
  CERTIFICATION = 'CERTIFICATION',
  SYSTEM = 'SYSTEM',
}

export enum NotificationPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export interface AppNotification {
  id: string;
  category: NotificationCategory;
  priority: NotificationPriority;
  title: string;
  message: string;
  icon: string; // emoji or icon key
  link?: string; // route to navigate to
  read: boolean;
  createdAt: string;
  /** The user ID this notification is for */
  recipientId: string;
  /** Who triggered this notification */
  actorName?: string;
}
